var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Banner'),_c('Partner'),_c('Services'),_c('Cta'),_c('Funfacts'),_c('Features'),_c('FeaturesTwo'),_c('Team'),_c('Feedback'),_c('WhyChooseUs'),_c('Blog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }